import React from 'react';

const LightContext = React.createContext({});

export default LightContext;